import { twMerge } from "tailwind-merge";
import { API_BASE_URL, APPLE_CLIENT_ID, CLIENT_ID, GITHUB_CLIENT_ID } from "../../constants.ts";
import { AppleIcon, GithubIcon, GoogleIcon } from "../Icons";
import Loader from "../Loader";

import { SocialAuthButtonsProps } from "./types.ts";
import Tooltip from "../Tooltip/index.tsx";

const SocialAuthButtons = ({
  isAuthorizing,
  refCode,
}: SocialAuthButtonsProps) => {
  const refString = refCode ? `&state=${refCode}` : "";

  // console.log(GITHUB_CLIENT_ID);

  const handleLoginWithGoogle = () => {
    window.location.href = `https://accounts.google.com/o/oauth2/v2/auth?response_type=code&client_id=${CLIENT_ID}&redirect_uri=${window.location.origin}/auth/login&scope=profile+email&prompt=select_account${refString}`;
  };

  const handleLoginWithApple = () => {
    window.location.href = `https://appleid.apple.com/auth/authorize?response_type=code&client_id=${APPLE_CLIENT_ID}&redirect_uri=${API_BASE_URL}/v1/auth/user/apple_redirect&scope=name+email&response_mode=form_post${refString}`;
  };
  const handleLoginWithGithub = () => {
    window.location.href = `https://github.com/login/oauth/authorize?client_id=${GITHUB_CLIENT_ID}&redirect_uri=${window.location.origin}/auth/login`;
  };

  const hostname = window.location.hostname;
  return (
    <ul className="appearAnimation flex gap-[1rem] justify-center">
      <li className={twMerge(["dev.on-demand.io","app.on-demand.io", "localhost"].includes(hostname) ? "block" : "hidden")}>
      <Tooltip
          place="bottom"
          className="!rounded !border-primary-300 !text-primary-300"
          tooltipContent="Login with Google"
        >
        <button
          onClick={handleLoginWithGoogle}
          className="rounded-full px-2 py-2 bg-neutral-800 hover:bg-neutral-600 flex w-full items-center justify-center gap-[0.5rem] text-[0.875rem] font-medium transition-colors"
          disabled={isAuthorizing}
        >
          {isAuthorizing ? (
            <>
              <Loader className="my-0 w-min [&_svg]:h-[1.374rem] [&_svg]:w-[1.374rem]" />
              {/* <p>Authenticating...</p> */}
            </>
          ) : (
            <>
              <GoogleIcon />
            </>
          )}
        </button>
        </Tooltip>
      </li>
      <li>
        <Tooltip
            place="bottom"
            className="!rounded !border-primary-300 !text-primary-300"
            tooltipContent="Login with Apple"
          >
          <button
            onClick={handleLoginWithApple}
            className="rounded-full px-[6px] py-[6px] bg-neutral-800 hover:bg-neutral-600 flex w-full items-center justify-center gap-[0.5rem] text-[0.875rem] font-medium transition-colors"
            disabled={isAuthorizing}
          >
            <AppleIcon />
          </button>
        </Tooltip>
      </li>
      <li>
        <Tooltip
              place="bottom"
              className="!rounded !border-primary-300 !text-primary-300"
              tooltipContent="Login with Github"
            >
          <button
            onClick={handleLoginWithGithub}
            className="rounded-full px-2 py-2 bg-neutral-800 hover:bg-neutral-600 flex w-full items-center justify-center gap-[0.5rem] text-[0.875rem] font-medium transition-colors"
            disabled={isAuthorizing}
          >
            <GithubIcon />
          </button>
        </Tooltip>
      </li>
    </ul>
  );
};

export default SocialAuthButtons;
